import { messageInfo } from '../messages';
export function getEmptyPlanGenerationMessage(operation) {
    return messageInfo(operation === 'points' ? 10593 : 10589).message_texts.ru;
}
export function explainPlanGenerationError(message) {
    const text = message.trim().replace(/\.$/, '');
    if (text === 'В плане нет пунктов для генерации точек')
        return getEmptyPlanGenerationMessage('points');
    if (text === 'Travel plan has no items for finance generation'
        || text === 'Добавьте пункты в план путешествия перед расчётом расходов')
        return getEmptyPlanGenerationMessage('finance');
    return message;
}
export function getPlanGenerationDisabledReason(operation, { loading = false, loadError = false, hasItems, generating = false, creditsUnavailable = false, }) {
    if (generating)
        return 'Генерация уже выполняется. Дождитесь её завершения.';
    if (loading)
        return 'Загружаем пункты плана. Дождитесь окончания загрузки.';
    if (loadError)
        return 'Не удалось загрузить пункты плана. Обновите страницу и повторите попытку.';
    if (hasItems === false)
        return getEmptyPlanGenerationMessage(operation);
    if (creditsUnavailable)
        return 'Не хватает ИИ-кредитов. Докупите кредиты для запуска генерации.';
    return '';
}
